module.exports = __webpack_public_path__ + "static/img/bg-ar.8c0fe443.webp";